import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { CheckoutForm } from "./CheckoutForm";
import { get, post } from "../../api/";

import { useAuth } from "../../hooks/useAuth";
import { Box, Button, CircularProgress, Divider, Typography } from "@mui/material";
import { Input } from "../Input";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { LoadingButton } from "@mui/lab";
import { Modal } from "../Modal";
import { ReactComponent as ThumbUP } from "../../assets/svgs/thumb-up.svg";
import { ReactComponent as ThunbDown } from "../../assets/svgs/thunb-down.svg";
import SuccessGif from "../../assets/gif/5de.gif";
import ErrorGif from "../../assets/gif/sad-face-emoji.gif";
import { updateApplicantAsync } from "../../utils";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const Payment = forwardRef((props, ref) => {
    const checkFormRef = useRef();
    const { getUserDetailsNotAsync, setUserDetailsNotAsync } = useAuth();
    let userDetails = getUserDetailsNotAsync();
    const [clientSecret, setClientSecret] = useState("");
    const [code, setCode] = useState("");
    const [appling, setAppling] = useState(false);
    const [promocode, setPromocode] = useState();
    const [openModal, setOpenModal] = useState(false);
    const [loadingPayment, setLoadingPayment] = useState(false);

    const query = new URLSearchParams(window.location.search);
    const paymentIntent = query.get("payment_intent");
    const paymentIntentClientSecret = query.get("payment_intent_client_secret");
    const redirectStatus = query.get("redirect_status");
    const status = query.get("success");

    useImperativeHandle(ref, (e) => ({
        async submit(newStep, isLast) {
            if (checkFormRef?.current) {
                checkFormRef?.current?.submit(newStep, isLast);
            } else {
                let applicant = userDetails.applicant;
                applicant.amount = 0;
                applicant.promocode = promocode?.Id ? promocode.Id : undefined;
                await updateApplicantAsync(userDetails.applicant, "payment");
                userDetails.applicant.isPaymentCompleted = true;
                setUserDetailsNotAsync(userDetails);
                return "Promocode applied";
            }
        },
    }));
    useEffect(() => {
        getPaymentDetails();
    }, []);

    const getPaymentDetails = async () => {
        const result = await post("payment/create-payment-intent", {
            items: [{ id: "xl-tshirt" }],
            email: userDetails.username,
            applicationId: userDetails.applicant.applicationId,
            name: userDetails.applicant.name,
            code: code,
        });
        if (result.isSuccess) {
            setClientSecret(result.data.clientSecret);
        }
    };

    const appearance = {
        theme: "stripe",
    };
    const options = {
        clientSecret,
        appearance,
    };

    const handleCouponChange = (value) => {
        setCode(value);
    };

    const handleApply = () => {
        if (code) {
            setAppling(true);
            post("payment/validate-promocode", {
                code: code,
            }).then((result) => {
                console.log("result", result);
                if (result.isSuccess) {
                    setPromocode(result.data);
                    getPaymentDetails();
                } else {
                    setPromocode(undefined);
                    getPaymentDetails();
                }
                setAppling(false);
                setOpenModal(true);
            });
        }
    };

    const getAmount = () => {
        let amount = 75.0;
        if (promocode) {
            amount = amount - amount * (promocode.Discount__c / 100);
        }
        return (Math.round(amount * 100) / 100).toFixed(2);
    };

    const closePromocodeModal = () => {
        setOpenModal(false);
        setLoadingPayment(true);
        setTimeout(() => {
            setLoadingPayment(false);
        }, 5000);
    };

    return (
        <div>
            <Box sx={{ mt: "-1.5rem", mb: "1rem" }}>
                <Typography color="text.primary" variant="h5" component="h6">
                    <b>Pay ${getAmount()} processing fee</b>
                </Typography>
            </Box>
            <Box>
                <Grid spacing={2} container sx={{ alignItems: "end", justifyContent: "space-between" }}>
                    <Grid xs={8} md={10} item>
                        <Input
                            id="coupon-code"
                            type="text"
                            placeholder="Enter coupon"
                            label={`Do you have an application promo code? Enter it here!`}
                            onChange={(value) => handleCouponChange(value)}></Input>
                    </Grid>
                    <Grid xs={4} md={2} item>
                        <LoadingButton
                            color="primary"
                            type="submit"
                            fullWidth
                            loading={appling}
                            variant="contained"
                            onClick={handleApply}
                            sx={{ height: "53px", marginTop: "-2.5rem" }}>
                            Apply
                        </LoadingButton>
                    </Grid>
                </Grid>
            </Box>
            <Divider sx={{ my: "1rem" }}></Divider>
            {clientSecret && !loadingPayment && (
                <Elements options={options} stripe={stripePromise}>
                    <CheckoutForm ref={checkFormRef} amount={getAmount()} promocode={promocode} />
                </Elements>
            )}
            {loadingPayment && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "4rem",
                        flexDirection: "column",
                        textAlign: "center",
                    }}>
                    <CircularProgress />
                    <Typography sx={{ mt: "1rem" }}>Loading payment...</Typography>
                </Box>
            )}

            <Modal
                open={openModal}
                title={promocode ? "Success" : "Sorry - Not a valid code!"}
                onClose={() => {
                    closePromocodeModal();
                }}
                maxWidth="md"
                hideActions={true}>
                <Box sx={{ width: "200px", textAlign: "center" }}>
                    {/* {promocode ? (
                        <img src={SuccessGif} style={{ width: "70px" }} alt="success"></img>
                    ) : (
                        <img style={{ width: "70px" }} src={ErrorGif} alt="error"></img>
                    )} */}
                    <Box>{promocode ? promocode.Message__c : "Not a valid promo code, please try again"}</Box>
                </Box>
            </Modal>
        </div>
    );
});

export { Payment };
